export default __webpack_public_path__ + "static/slide_5-c57148e65c646f1516900ef103694589.png";